//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

export enum KEYS {
  BACKSPACE = 'Backspace',
  COMMA = ',',
  ENTER = 'Enter',
  ESC = 'Escape',
  SHIFT = 'Shift',
  SPACE = ' ',
  TAB = 'Tab',
}

export const KEYCODES = {
  [KEYS.BACKSPACE]: 8,
  [KEYS.COMMA]: 188,
  [KEYS.ENTER]: 13,
  [KEYS.ESC]: 27,
  [KEYS.SHIFT]: 16,
  [KEYS.SPACE]: 32,
  [KEYS.TAB]: 9,
};
